import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  const dt = new Date().getFullYear();

  return (
    <footer className="bg-[#0b1623] text-white w-full mt-auto">
      {" "}
      {/* Add mt-auto */}
      {/* MAIN CONTENT */}
      <div className="max-w-8xl mx-auto px-6 md:px-16 pt-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 2xl:gap-34">
          {/* BRAND */}
          <div>
            <h2 className="text-2xl font-bold tracking-wide">
              <span className="text-yellow-500">Nex</span>Testify
            </h2>
            <p className="mt-1 text-gray-400 text-sm leading-relaxed">
              NexTestify empowers educators and organizations with smart
              assessment tools, AI-driven question creation, and seamless exam
              management.
            </p>
          </div>

          {/* PRODUCTS */}
          <div>
            <h5 className="font-semibold text-lg mb-6 pl-3 border-l-2 border-yellow-500 2xl:mr-16 tracking-wide">
              Features
            </h5>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="group flex items-center gap-2 cursor-pointer">
                <span className="text-yellow-500 transform group-hover:translate-x-1 transition duration-300">
                  ›
                </span>
                <Link
                  to="/SkillsAndKnowledgeAssessment"
                  className="group-hover:text-yellow-400 transition"
                >
                  Skills and Knowledge Assessment
                </Link>
              </li>
              <li className="group flex items-center gap-2">
                <span className="text-yellow-500 transform group-hover:translate-x-1 transition duration-300">
                  ›
                </span>
                <Link
                  to="/SelfGrading"
                  className="group-hover:text-yellow-400 transition"
                >
                  Self-Grading & Choice Questions
                </Link>
              </li>
              <li className="group flex items-center gap-2">
                <span className="text-yellow-500 transform group-hover:translate-x-1 transition duration-300">
                  ›
                </span>
                <Link
                  to="/Customization"
                  className="group-hover:text-yellow-400 transition"
                >
                  Test Maker
                </Link>
              </li>
              <li className="group flex items-center gap-2">
                <span className="text-yellow-500 transform group-hover:translate-x-1 transition duration-300">
                  ›
                </span>
                <Link
                  to="/AI"
                  className="group-hover:text-yellow-400 transition"
                >
                  AI Question Creation
                </Link>
              </li>
              <li className="group flex items-center gap-2">
                <span className="text-yellow-500 transform group-hover:translate-x-1 transition duration-300">
                  ›
                </span>
                <Link
                  to="/Proctoring"
                  className="group-hover:text-yellow-400 transition"
                >
                  Proctoring
                </Link>
              </li>
            </ul>
          </div>

          {/* RESOURCES */}
          <div>
            <h5 className="font-semibold text-lg mb-6 border-l-2 border-yellow-500 2xl:mr-16 tracking-wide">
              Resources
            </h5>
            <ul className="space-y-3 text-gray-400 text-sm">
              {[
                { name: "About Us", path: "/about-us" },
                { name: "Blogs", path: "/blogs" },
                { name: "Management", path: "/management" },
                { name: "Contact Us", path: "/#section6" },
              ].map((item, i) => (
                <li key={i} className="group flex items-center gap-2">
                  <span className="text-yellow-500 transform group-hover:translate-x-1 transition duration-300">
                    ›
                  </span>
                  <Link
                    to={item.path}
                    className="group-hover:text-yellow-400 transition"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h5 className="font-semibold text-lg mb-6 border-l-2 border-yellow-500 tracking-wide">
              Contact Us
            </h5>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="hover:text-yellow-400 transition">
                <a href="mailto:Support@resilink.in">Support@Nextestify.com</a>
              </li>
              <li className="hover:text-yellow-400 transition">
                <a href="tel:+919566558355">+91-9566558355</a>
              </li>
            </ul>
            {/* SOCIAL ICONS */}
            <div className="flex gap-4 mt-6 ml-6 2xl:ml-24">
              {[FaFacebookF, FaXTwitter, FaInstagram, FaLinkedinIn].map(
                (Icon, i) => (
                  <div
                    key={i}
                    className="w-11 h-11 flex items-center justify-center border border-gray-600 rounded-full text-gray-400 
                    hover:bg-yellow-500 hover:text-white hover:scale-110 transition-all duration-300 cursor-pointer"
                  >
                    <Icon size={16} />
                  </div>
                ),
              )}
            </div>
          </div>
        </div>
      </div>
      {/* DIVIDER */}
      <div className="border-t mt-2 border-gray-800"></div>
      {/* BOTTOM */}
      <div className="text-gray-400 text-center py-2 text-sm tracking-wide">
        © COPYRIGHT {dt} BY SANKARA SOFTWARE SERVICES PRIVATE LIMITED
      </div>
    </footer>
  );
};

export default Footer;
